// 頂部列的搜尋框：外觀是輸入框，按下（或 ⌘K／Ctrl+K、「/」）開啟指令面板。
// 清單正在以關鍵字篩選時顯示該關鍵字。
import type { Ref } from 'react';
import { t } from '../../i18n/zh-TW.ts';
import { ICON, Search } from '../../ui/icons/index.ts';

const isMac = typeof navigator !== 'undefined' && /Mac|iPhone|iPad/.test(navigator.platform);

export function SearchTrigger({
  query,
  onOpen,
  buttonRef,
}: {
  query: string;
  onOpen: () => void;
  buttonRef?: Ref<HTMLButtonElement>;
}) {
  return (
    <button
      ref={buttonRef}
      type="button"
      className="search search-trigger"
      aria-label={t.palette.trigger}
      aria-haspopup="dialog"
      onClick={onOpen}
    >
      <Search {...ICON} className="search-icon" />
      <span className={query ? 'search-text has-query' : 'search-text'}>{query || t.search.placeholder}</span>
      <kbd>{t.palette.shortcut(isMac)}</kbd>
    </button>
  );
}
